import { AuthenticatedLayout } from "../../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { PayrollAdjustmentReport } from "../../../components/Reports/PayrollAdjustment";

export const PayrollAdjustmentReportPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Adjustment Report"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
      ]}
      mainContents={<PayrollAdjustmentReport/>}
    />
  );
};
